// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);

Vue.config.devtools = true;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  created() {
    // this.$Countly.q.push(["track_sessions"]);
    // this.$Countly.q.push(["track_pageview"]);
    // this.$Countly.q.push(["track_clicks"]);
    // this.$Countly.q.push(["track_scrolls"]);
    // this.$Countly.q.push(["track_errors"]);
    // this.$Countly.q.push(["track_links"]);
    // this.$Countly.q.push(["track_forms"]);
    // this.$Countly.q.push(["collect_from_forms"]);
  }
});



// WEBPACK FOOTER //
// ./src/main.js